export default "__VITE_ASSET__3RgE0yFd__"